import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import Selector from '../../../../selectors/layers/main/jackpots';
import Animation from './animation';
import CountUp from '../../../../utils/countup';
import ImageUtil from '../../../../utils/image';

export default () => {
    const {jackpots} = useSelector(Selector);
    console.log(jackpots);

    useEffect(() => {
        Animation.start();
        return () => Animation.stop();
    }, []);

    return (
        <div className="jackpots">
            <div className="jackpot orange active" style={{zIndex: 1, opacity: 1}}>
                <div className="name">
                    <ImageUtil
                        path={'/images/main/jackpots/super-jackpot.png'}
                        alt={'Super Jackpot'} />
                </div>
                <CountUp value={jackpots.super} currency_symbol={'$'} />
            </div>
            <div className="jackpot blue" style={{zIndex: 0, opacity: 0}}>
                <div className="name">
                    <ImageUtil
                        path={'/images/main/jackpots/mega-jackpot.png'}
                        alt={'Mega Jackpot'} />
                </div>
                <CountUp value={jackpots.mega} currency_symbol={'$'} />
            </div>
            <div className="jackpot purple" style={{zIndex: 0, opacity: 0}}>
                <div className="name">
                    <ImageUtil
                        path={'/images/main/jackpots/ultra-jackpot.png'}
                        alt={'Ultra Jackpot'} />
                </div>
                <CountUp value={jackpots.ultra} currency_symbol={'$'} />
            </div>
        </div>
    )
}